import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { BASE_URL } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class UsersService {

	constructor(
		private http: Http,
		private router: Router,
		private toastr: ToastrService
	) { }

	private loginHeaders = new Headers({ 'Content-Type': 'application/json' });
	private loginOptions = new RequestOptions({ headers: this.loginHeaders });

	//Login & Logout
	login(data) {
		return this.http.post(BASE_URL + 'login/admin', data, this.loginOptions)
			.map((response: Response) => {
				const data = response.json();
				if (data.user && data.user.security_token) {
                    const roleData = data.user.roles[data.user.roles.length - 1];
					localStorage.setItem('securityToken', data.user.security_token);
					localStorage.setItem('clientId', data.user.client_id);
					localStorage.setItem('userId', data.user.id);
					localStorage.setItem('username', data.user.username);
					localStorage.setItem('roleId', roleData.id);
					localStorage.setItem('roleName', roleData.role.name);
				}
			});
	}

	logout() {
		return this.http.post(BASE_URL + 'logout', this.getClientId(), this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	// Create user
	createUser(data) {
		return this.http.post(`${BASE_URL}users`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	editUser(id, data) {
		return this.http.put(`${BASE_URL}users/${id}`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	enableUser(id) {
		return this.http.get(`${BASE_URL}users/${id}/enable`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	disableUser(id) {
		return this.http.get(`${BASE_URL}users/${id}/disable`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	/*autoLogin(data) {
		console.log('data: ', data);
		return this.http.post(BASE_URL + 'auto_login', data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}*/

	//Passwords
	forgotPassword(data) {
		return this.http.put(`${BASE_URL}user/password/reset/email/admin`, data)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	setPassword(reg_token, data) {
		return this.http.post(`${BASE_URL}users/password/reset/admin/${reg_token}`, data)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	setAppPassword(reg_token, data) {
		return this.http.post(`${BASE_URL}users/password/reset/${reg_token}`, data)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	changePassword(data) {
		return this.http.post(`${BASE_URL}user/change_password/admin`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificUsers(filter_term) {
		return this.http.get(`${BASE_URL}users/active?filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
    }
    
	providerRegistration(data) {
		return this.http.post(BASE_URL + 'providers/register', data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//Register confirm from admin
	memberRegistrationConfirm(reg_token, data) {
		return this.http.post(`${BASE_URL}users/password/set/${reg_token}`, data)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	// Additional card
 	additionalCardConfirm(reg_token, data) {
		return this.http.post(`${BASE_URL}users/card/confirm/${reg_token}`, data)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	 }

	//Register confirm from mobile app
	userRegistrationConfirm(reg_token) {
		return this.http.get(`${BASE_URL}registration_confirm/${reg_token}`)
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	// Users
	getAllUsers(offset, limit, draw, filter, order_column, order_direction, profile_type) {
		return this.http.get(BASE_URL + `users/datatable/${profile_type}?start=${offset}&length=${limit}&search[value]=${filter}&draw=${draw}&order[0][column]=${order_column}&order[0][dir]=${order_direction}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
    }
    
    // Devices
	getAllDevices(offset, limit, draw, filter, order_column, order_direction) {
		return this.http.get(BASE_URL + `clients/datatable?start=${offset}&length=${limit}&search[value]=${filter}&draw=${draw}&order[0][column]=${order_column}&order[0][dir]=${order_direction}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
    }
    
    disableDevice(data) {
		return this.http.put(`${BASE_URL}device/disconnect`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}
	
	getSingleUser(id) {
		return this.http.get(`${BASE_URL}users/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	deleteUser(id) {
		return this.http.delete(`${BASE_URL}users/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//User roles
	getRoles() {
		return this.http.get(BASE_URL + 'roles', this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//File upload
	fileUpload(file, id) {
		const data = new FormData();
		data.append('media_file', file);

		return this.http.post(`${BASE_URL}media/upload/${id}`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//Error function
	_handleError(error) {
		if (error.status === 401 || error.status === 455 || error.status === 403 || error.status === 498) {
			this.toastr.warning('Vaš sigurnosni token je istekao, molimo prijavite se ponovno');
			localStorage.clear();
			this.router.navigate([`/login`]);
		} else {
			return Observable.throw(error.json());
		}
	}

	//Header with token
	private getToken() {
		const token = localStorage.getItem('securityToken');
		if (token) {
			const headers = new Headers({
				'Content-Type': 'application/json',
				'Securitytoken': token,
			});
			return new RequestOptions({ headers: headers });
		}
	}

	private getClientId() {
		const clientObject = { "client_id" : localStorage.getItem('clientId') };
		return clientObject;
	}
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/services/users/users.service.ts